<template>
    <div class="filteritem">
    <v-select 
      class="drop font-weight-bold text-text text-subtitle-1"
      hide-details
      density="compact"
      variant="underlined"
      v-model="localValue"
      :name="filterKey" 
      :item-props="$PAG.itemPropsDisabled" 
      :label="selectorItem.SelectorName" 
      :items="items"
      multiple  
      :menu-props="selectOptionsWhiteBackground"
    >
    </v-select>
    </div>
</template>

<script setup>
const { $PAG } = useNuxtApp()

const props = defineProps({
  selectorItem: {
    type: Object,
    default: {},
  },  
  pagData: {
    type: Object,
    default: {},
  }, 
  modelValue: {  // Accept v-model 
    type: Array,
    default: () => [],
  }, 
})


const emit = defineEmits(['update:modelValue'])

// Computed voor de filter key
const filterKey = computed(() => 
  $PAG.getFilterKey(props.selectorItem.AttribuutSelectorName, props.pagData)
)

// Computed voor de items
const items = computed(() => 
  $PAG.addItems(props.selectorItem.AttribuutSelectorName, props.pagData, props.selectorItem, true)
)

// Local value met two-way binding
const localValue = computed({
  get: () => props.modelValue || [],  // Ensure array
  set: (value) => emit('update:modelValue', value)
})
</script>